import { DisplayVariantType, Paragraph, TitleVariantType } from '@purpurds/purpur';
import { ReactNode } from 'react';

import CardContentWrapper from '../card-content-wrapper/CardContentWrapper';

import PurpurIcon, { IconName } from 'components/purpur/Icon/Icon';
import './UspComponent.scss';
import { UspItem } from 'pages/FlexibleSolutionsTemplate/models';

type Props = {
  title: string;
  preamble: ReactNode;
  uspList: UspItem[];
  solutionsVersion?: boolean;
  backgroundColor?: string;
  isTitleCentered?: boolean;
  titleVariant?: TitleVariantType | DisplayVariantType;
  cta?: {
    text?: string;
    url?: string;
  };
};

const UspComponent = ({
  title,
  preamble,
  uspList,
  solutionsVersion,
  backgroundColor,
  cta,
  isTitleCentered = false,
  titleVariant = 'title-300',
}: Props) => {
  const is3PerLine = uspList.length === 3 || uspList.length === 6;
  return (
    <section
      className={`usp-section${solutionsVersion ? '--secondary' : ''}`}
      style={{ backgroundColor: backgroundColor }}
    >
      <CardContentWrapper
        title={title}
        preamble={preamble ?? undefined}
        cta={cta}
        titleVariant={isTitleCentered ? 'display-25' : titleVariant}
        isTitleCentered={isTitleCentered}
      >
        <div className="usp-section__icon-list">
          {uspList.map((usp, id) => {
            const icon = usp.iconName ? usp.iconName : 'error';
            return (
              <div
                key={`${usp.title}-${id}`}
                className={`usp-section__usp-unit-wrapper${is3PerLine ? '-x3' : ''}`}
              >
                <div
                  className={`usp-section__icon-wrapper${solutionsVersion ? '--secondary' : ''}`}
                >
                  <PurpurIcon iconName={icon as IconName} size={'xl'} />
                </div>
                <div
                  className={
                    usp.description ? 'usp-section__icon-text' : 'usp-section__icon-text--centered'
                  }
                >
                  {usp.title && <b>{usp.title}</b>}
                  {usp.description && <Paragraph>{usp.description}</Paragraph>}
                </div>
              </div>
            );
          })}
        </div>
      </CardContentWrapper>
    </section>
  );
};

export default UspComponent;
